import { useState, useRef, useEffect } from 'react';

/**
 * MultiComboboxSelect — select múltiple con buscador.
 * value: string[]
 * onChange: (string[]) => void
 */
export function MultiComboboxSelect({ options = [], value = [], onChange, placeholder = 'Seleccionar...', large = false }) {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    function handler(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setQuery('');
      }
    }
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const filtered = options.filter((o) =>
    o.label.toLowerCase().includes(query.toLowerCase())
  );

  function toggle(val) {
    if (value.includes(val)) onChange(value.filter((v) => v !== val));
    else onChange([...value, val]);
  }

  const selectedLabels = options.filter((o) => value.includes(o.value)).map((o) => o.label);

  const btnCls = large
    ? "w-full min-w-[180px] text-left border border-gray-200 rounded-md px-4 py-3 text-base font-['Inter'] bg-white focus:outline-none focus:ring-2 focus:ring-[#0D2B5C] flex items-center justify-between gap-2"
    : "w-full text-left border border-gray-200 rounded-md px-3 py-2 text-sm font-['Inter'] bg-white focus:outline-none focus:ring-2 focus:ring-[#0D2B5C] flex items-center justify-between gap-2";

  return (
    <div ref={ref} className="relative">
      <button type="button" onClick={() => setOpen((v) => !v)} className={btnCls}>
        <span className={selectedLabels.length === 0 ? 'text-gray-400' : 'text-[#0D2B5C]'}>
          {selectedLabels.length === 0
            ? placeholder
            : selectedLabels.length === 1
            ? selectedLabels[0]
            : `${selectedLabels.length} seleccionados`}
        </span>
        <span className="text-gray-400 text-xs shrink-0">▾</span>
      </button>

      {open && (
        <div className="absolute z-20 mt-1 w-full min-w-[200px] bg-white border border-gray-200 rounded-md shadow-lg">
          <div className="p-2">
            <input
              autoFocus
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Buscar..."
              className="w-full border border-gray-200 rounded px-2 py-1.5 text-sm font-['Inter'] focus:outline-none"
            />
          </div>
          <ul className="max-h-52 overflow-y-auto">
            {filtered.map((o) => (
              <li
                key={o.value}
                onClick={() => toggle(o.value)}
                className="flex items-center gap-2 px-3 py-2 text-sm font-['Inter'] hover:bg-gray-50 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={value.includes(o.value)}
                  onChange={() => {}}
                  className="rounded accent-[#0D2B5C]"
                />
                <span className="text-[#0D2B5C]">{o.label}</span>
              </li>
            ))}
            {!filtered.length && (
              <li className="px-3 py-2 text-sm text-gray-400 font-['Inter']">Sin resultados</li>
            )}
          </ul>
          {value.length > 0 && (
            <div className="p-2 border-t border-gray-100">
              <button
                onClick={() => { onChange([]); setOpen(false); }}
                className="text-xs text-[#6B7280] hover:text-[#0D2B5C] font-['Inter'] transition-colors"
              >
                Limpiar selección
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
